import { Loading } from '../components/styled';
import { colors } from '../globalStyles';

const loaderType = 'Oval';

export const Loader = () => (
  <Loading type={loaderType} color={colors.green} height={50} width={50} />
);

export const LoaderSmall = () => (
  <Loading type={loaderType} color={colors.green} height={30} width={30} />
);

export const LoaderButton = () => (
  <Loading type={loaderType} color={colors.green} height={20} width={20} />
);
